import Vue from 'vue'
import ElementUI from 'element-ui';
import  'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
// Vue.use(Button)
// Vue.use(Button)
// Vue.use(Form)
// Vue.use(FormItem)
// Vue.use(Input)
// Vue.use(Menu)
// Vue.use(Submenu)
// Vue.use(MenuItem)
// Vue.use(MenuItemGroup)
// Vue.use(Image)
// Vue.use(Dialog)
// Vue.use(Table)
// Vue.use(TableColumn)
// Vue.use(Link)
// Vue.use(Select)
// Vue.use(Option)
// Vue.use(Pagination)
// Vue.use(Loading)
// Vue.use(Autocomplete)
// Vue.use(Tabs)
// Vue.use(TabPane)
// Vue.use(Row)
// Vue.use(Col)
// Vue.use(Upload)
// Vue.use(Icon)
// Vue.use(Tooltip)
// Vue.prototype.$msgbox = MessageBox;
// Vue.prototype.$alert = MessageBox.alert;
// Vue.prototype.$confirm = MessageBox.confirm;
// Vue.prototype.$prompt = MessageBox.prompt;
// Vue.prototype.$message = Message;
